<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import cookieUtil from '@/api/cookieUtil'
import {
  intervalRefreshToken,
  setDomain,
  oldWeb2NewWebSetParam
} from '@/api/base'
export default {
  name: 'App',
  data () {
    return {
      get_webconfig_url: 'webconfig/type',
      is_created: false,
    }
  },
  created () {
    //切换标签页时，复制Cookie中的一些登陆信息到SessionStorage中
    this.copyCookieToSessionStorage()

    //如果是旧项访问新项目要设置一些参数
    oldWeb2NewWebSetParam()

    //设置域名
    setDomain()

    //[xsw 20181104] 设置刷新令牌的定时器（在这里设置是为了解决刷新页面是定时器(js)失效的问题）
    intervalRefreshToken()

    this.showMessage()
  },
  updated () {
    this.showMessage()
  },
  methods: {
    /**
     * 切换标签页时，复制Cookie中的一些登陆信息到SessionStorage中
     */
    copyCookieToSessionStorage () {
      if (cookieUtil.get('new_token') && !this.$sessionStorageUtil.get('token')) {
        console.log('复制Cookie中的登陆信息到SessionStorage中')
        this.$sessionStorageUtil.set('token', cookieUtil.get('new_token'))
        this.$sessionStorageUtil.set('token_type', cookieUtil.get('new_token_type'))
        this.$sessionStorageUtil.set('refresh_token', cookieUtil.get('new_refresh_token'))
        this.$sessionStorageUtil.set('refresh_token_time', cookieUtil.get('new_refresh_token_time')) //设置令牌刷新时间
        this.$sessionStorageUtil.set('login_type', cookieUtil.get('new_login_type'))
        if (cookieUtil.get('new_open_id')) {
          this.$sessionStorageUtil.set('open_id', cookieUtil.get('new_open_id'))
        }
        if (cookieUtil.get('new_login_type') == 0) {
          //销售
          this.$sessionStorageUtil.set('agent_username', cookieUtil.get('new_agent_username'))
          this.$sessionStorageUtil.set('category_code', cookieUtil.get('new_category_code'))
          this.$sessionStorageUtil.set('customer_service_name', cookieUtil.get('new_customer_service_name'))
          if (cookieUtil.get('new_domain_name') && cookieUtil.get('new_web_type')) {
            this.$sessionStorageUtil.set('domain_name', cookieUtil.get('new_domain_name'))
            this.$sessionStorageUtil.set('web_type', cookieUtil.get('new_web_type'))
          } else {
            this.$sessionStorageUtil.remove('domain_name')
            this.$sessionStorageUtil.remove('web_type')
            cookieUtil.remove('new_domain_name')
            cookieUtil.remove('new_web_type')
          }
          this.$sessionStorageUtil.remove('username')
          cookieUtil.remove('new_username')
        } else if (cookieUtil.get('new_login_type') == 1) {
          //会员
          this.$sessionStorageUtil.set('member_id', cookieUtil.get('new_member_id'))
          this.$sessionStorageUtil.set('bind_agent', cookieUtil.get('new_bind_agent'))
          this.$sessionStorageUtil.set('name', cookieUtil.get('new_name'))
          this.$sessionStorageUtil.set('username', cookieUtil.get('new_username'))
          this.$sessionStorageUtil.set('member_types', cookieUtil.get('new_member_types'))
          if (cookieUtil.get('new_domain_name') && cookieUtil.get('new_web_type')) {
            this.$sessionStorageUtil.set('domain_name', cookieUtil.get('new_domain_name'))
            this.$sessionStorageUtil.set('web_type', cookieUtil.get('new_web_type'))
          }
          this.$sessionStorageUtil.remove('agent_username')
          cookieUtil.remove('new_agent_username')
        }
      }
    },

    //TODO xsw 当前页面操作成功，跳转到下个页面才显示消息的统一作法,
    //用法：在当前页面设置 this.$sessionStorageUtil.set('next_message','消息内容')
    showMessage () {
      let message = this.$sessionStorageUtil.get('next_message')
      if (message) {
        this.$nextTick(function () {
          let type = this.$sessionStorageUtil.get('next_message_type')
          let time = this.$sessionStorageUtil.get('next_message_time')
          this.$sessionStorageUtil.remove('next_message')
          this.$sessionStorageUtil.remove('next_message_type')
          this.$sessionStorageUtil.remove('next_message_time')
          window.setTimeout(() => {
            this.$msg(message, type, time)
          }, 200)
        })
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  min-width: 1000px;
  position: relative;
}
body {
  font-family: 'Microsoft YaHe', 'SimSun', Verdana, sans-serif;
  color: #444444;
  font-size: 14px;
  background: #fff;
  width: 100%;
  height: 100%;
  position: relative;
  overflow-x: hidden;
}
.wrap {
  position: relative;
  margin: 0px auto;
  width: 1000px;
  padding: 0px;
}
.wrap1920 {
  margin: 0px auto;
  width: 100%;
  max-width: 1920px;
  min-width: 1000px;
}
.wrap1200 {
  width: 1160px;
  margin: 0 auto;
  position: relative;
  padding-left: 40px;
}
.clear {
  width: 0;
  height: 0;
  font-size: 0;
  line-height: 0;
  clear: both;
  overflow: hidden;
}
body,
html,
div,
p,
table,
ul,
ol,
li,
dl,
dt,
dd,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0px;
  padding: 0px;
}
ul,
ol,
li,
dl,
dt,
dd {
  list-style: none;
}
div {
  text-align: left;
}
img,
a {
  border: none;
}
em,
i {
  font-style: normal;
}
a {
  outline: none;
  text-decoration: none;
}
.external-div {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  position: relative;
  /* overflow: hidden; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue